export { C as City, F as FEMALE, H as HasCountableForm, a as HasGender, L as Localization, M as MALE, N as Name, P as Partner, T as TrustedValue, U as UNSPECIFIED, L as default } from './localization-6d0f9260.js';
import 'html-entities/lib/xml-entities';
import './counted-form/index.js';
